<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chaptertitle"><a id="p9"></a> Kathy Austin's Nutty French Toast</h1>
<p class="left">"This is a great twist to the traditional French toast," says Kathy Austin from Houston, Texas. "It has a nutty texture and lots of protein! Great for those cold mornings before heading out on the road!" Well, once you whip up a batch of these, you will be nuts about them too. What a great way to start the day before a winter's ride on your Harley.</p>
<p class="timebreak"> <br/></p>
<table>
<tr>
<td align="left" valign="top"><a id="p10"></a> <b>2</b></td>
<td align="left" valign="top"><b>large eggs</b></td>
</tr>
<tr>
<td align="left" valign="top"><b>1</b></td>
<td align="left" valign="top"><b>cup milk</b></td>
</tr>
<tr>
<td align="left"></td>
<td align="left" valign="top"><b>Granulated sugar</b></td>
</tr>
<tr>
<td align="left"></td>
<td align="left" valign="top"><b>Crushed nuts (almonds, pecans, cashews, etc.)</b></td>
</tr>
<tr>
<td align="left" valign="top"></td>
<td align="left" valign="top"><b>Ground cinnamon</b></td>
</tr>
<tr>
<td align="left" valign="top"></td>
<td align="left" valign="top"><b>Ground nutmeg</b></td>
</tr>
<tr>
<td align="left"></td>
<td align="left" valign="top"><b>Sliced bread (white or wheat, the thicker the better) </b></td>
</tr>
<tr>
<td align="left"></td>
<td align="left" valign="top"><b>Butter (for cooking and to put on after cooking) </b></td>
</tr>
<tr>
<td align="left"></td>
<td align="left" valign="top"><b>Confectioners' sugar (optional) </b></td>
</tr>
<tr>
<td align="left"></td>
<td align="left" valign="top"><b>Syrup (optional)</b></td>
</tr>
</table>
<ol>
<li>In a large shallow bowl, mix the eggs and milk together well. Add granulated sugar, crushed nuts, cinnamon, and nutmeg to your taste.</li>
<li>Heat a large nonstick skillet (Silverstone or Teflon) over medium heat and melt some butter to cover the bottom or coat with nonstick cooking spray.</li>
<li>Place several slices of bread in the egg mixture and coat on both sides, letting the excess drip off a bit.</li>
<li>Lay the bread in the skillet and cook on both sides until golden brown.</li>
<li>Serve with butter, sprinkle with confectioners' sugar, if desired, and serve with syrup, if desired.</li>
</ol>
<p class="timebreak"> <br/></p>
<p class="right"><b><span style="font-size: smaller">MAKES</span> 4 <span style="font-size: smaller">TO</span> 6 <span style="font-size: smaller">SERVINGS</span></b></p>
<p class="follow"><img alt="[Image]" class="art" id="fig_BikerBillysHogWildOnAHarleyCookbook-26" src="images/BikerBillysHogWildOnAHarleyCookbook-26.jpg" width="100%"/></p>
<p class="left"><b><em>Kathy Austin's 1995 883 Sporty</em></b></p>
<p class="follow"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c007.vue?4237113d